// hooks/useCashfreeSdk.js
import { useState, useEffect } from 'react';
import { load } from '@cashfreepayments/cashfree-js';

export function useCashfreeSdk() {
  const [sdk, setSdk] = useState(null);

  useEffect(() => {
    const initializeSdk = async () => {
      try {
        const cashfree = await load({ mode: 'production' }); // or 'sandbox'
        setSdk(cashfree);
      } catch (error) {
        console.error('❌ Failed to initialize Cashfree SDK:', error);
      }
    };

    initializeSdk();
  }, []);

  return sdk;
}
